 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPS00COVER from '@/components/OEBPS/00-cover'
 import OEBPS01HALFTITLE from '@/components/OEBPS/01-halftitle'
 import OEBPS02TITLEPAGE from '@/components/OEBPS/02-titlepage'
 import OEBPS03COPYRIGHT from '@/components/OEBPS/03-copyright'
 import OEBPS04DEDICATION from '@/components/OEBPS/04-dedication'
 import OEBPS05CONTENTS from '@/components/OEBPS/05-contents'
 import OEBPS06PREFACE from '@/components/OEBPS/06-preface'
 import OEBPS07ACK from '@/components/OEBPS/07-ack'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSPART1 from '@/components/OEBPS/part1'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCH09 from '@/components/OEBPS/ch09'
 import OEBPSCH10 from '@/components/OEBPS/ch10'
 import OEBPSCH11 from '@/components/OEBPS/ch11'
 import OEBPSCH12 from '@/components/OEBPS/ch12'
 import OEBPSPART2 from '@/components/OEBPS/part2'
 import OEBPSCH13 from '@/components/OEBPS/ch13'
 import OEBPSCH14 from '@/components/OEBPS/ch14'
 import OEBPSCH15 from '@/components/OEBPS/ch15'
 import OEBPSCH16 from '@/components/OEBPS/ch16'
 import OEBPSCH17 from '@/components/OEBPS/ch17'
 import OEBPSCH18 from '@/components/OEBPS/ch18'
 import OEBPSCH19 from '@/components/OEBPS/ch19'
 import OEBPSPART3 from '@/components/OEBPS/part3'
 import OEBPSCH20 from '@/components/OEBPS/ch20'
 import OEBPSNOTE from '@/components/OEBPS/note'
 import OEBPSNOTE1 from '@/components/OEBPS/note1'
 import OEBPSAPPA from '@/components/OEBPS/appa'
 import OEBPSAPPB from '@/components/OEBPS/appb'
 import OEBPSAPPC from '@/components/OEBPS/appc'
 import OEBPSINDEX from '@/components/OEBPS/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/00-cover",
 			"name" : "OEBPS/00-cover",
 			"component" : OEBPS00COVER
 		},
 		{
 			"path" : "/OEBPS/01-halftitle",
 			"name" : "OEBPS/01-halftitle",
 			"component" : OEBPS01HALFTITLE
 		},
 		{
 			"path" : "/OEBPS/02-titlepage",
 			"name" : "OEBPS/02-titlepage",
 			"component" : OEBPS02TITLEPAGE
 		},
 		{
 			"path" : "/OEBPS/03-copyright",
 			"name" : "OEBPS/03-copyright",
 			"component" : OEBPS03COPYRIGHT
 		},
 		{
 			"path" : "/OEBPS/04-dedication",
 			"name" : "OEBPS/04-dedication",
 			"component" : OEBPS04DEDICATION
 		},
 		{
 			"path" : "/OEBPS/05-contents",
 			"name" : "OEBPS/05-contents",
 			"component" : OEBPS05CONTENTS
 		},
 		{
 			"path" : "/OEBPS/06-preface",
 			"name" : "OEBPS/06-preface",
 			"component" : OEBPS06PREFACE
 		},
 		{
 			"path" : "/OEBPS/07-ack",
 			"name" : "OEBPS/07-ack",
 			"component" : OEBPS07ACK
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
 		{
 			"path" : "/OEBPS/part1",
 			"name" : "OEBPS/part1",
 			"component" : OEBPSPART1
 		},
 		{
 			"path" : "/OEBPS/ch02",
 			"name" : "OEBPS/ch02",
 			"component" : OEBPSCH02
 		},
 		{
 			"path" : "/OEBPS/ch03",
 			"name" : "OEBPS/ch03",
 			"component" : OEBPSCH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js